module.exports = __webpack_public_path__ + "static/media/top_losers.9195ae42.svg";